<template>
    <Filters
        btn-filter-id="btn-charts-filter"
        useDefaultSearchButton
        @search="onClickSearch"
    >
        <Departments showLabel :value.sync="departments" />
        <Committees multiple lazyLoading :value.sync="committees" />
        <Questionnaires
            lazyLoading
            :model.sync="questionnaires"
            :defaultSelecteds="false"
        />
        <TextArea
            :label="$t('people.searchByName')"
            :description="$t('people.instructions.bulkSearch')"
            @lines="names = $event"
        />
    </Filters>
</template>
<script>
import Filters from '@/views/components/filters'
import {
    Departments,
    CTextArea as TextArea,
    Committee as Committees,
} from '@/views/components/fields'
import { Questionnaires } from '@/views/values/components'

export default {
    components: {
        Filters,
        TextArea,
        Committees,
        Departments,
        Questionnaires,
    },
    data() {
        return {
            names: [],
            committees: [],
            departments: [],
            questionnaires: [],
        }
    },
    methods: {
        onClickSearch() {
            const filters = this.getParsedFilters()
            this.$emit('filter', filters)
        },
        getParsedFilters() {
            const getValue = (v) => v.value
            return {
                names: this.names,
                committees: this.committees.map(getValue),
                departments: this.departments.map(getValue),
                questionnaires: this.questionnaires.map(getValue),
            }
        },
    },
}
</script>
